'use strict';

var unified = require('unified');
var parse = require('remark-parse');
var stringify = require('remark-stringify');

module.exports = unified().use(parse).use(stringify).freeze();



//////////////////
// WEBPACK FOOTER
// ./~/remark/index.js
// module id = 230
// module chunks = 147254134005266 182246549230831 215303740077764